import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchGroupsDataFailure,
  fetchGroupsDataSuccess,
} from "../slices/features/groups";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* groupsSaga(action: any) {
  const { payload } = action;
  const { id, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.getGroups,
      baseUrl,
      id,
      meta
    );

    yield put(fetchGroupsDataSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchGroupsDataFailure({ statusCode, statusText }));
  }
}

export function* watchGroups() {
  yield takeLatest(RequestTypes.GET_GROUP_LIST_REQUEST, groupsSaga);
}
